import { FormMultiselect } from '@shared/ui';
import { useGetEmploymentType } from '@entities/employmentType';
import { Loader, type MultiSelectProps } from '@mantine/core';

interface FormGuideEmploymentTypeProps extends MultiSelectProps {
  title?: string;
  description?: string;
  placeholder?: string;
}

export const FormGuideEmploymentType = ({
  title = 'Тип занятости',
  description = 'На постоянную занятость или разовая работа по найму',
  placeholder = 'Выберите',
  ...props
}: FormGuideEmploymentTypeProps) => {
  const { data, isLoading } = useGetEmploymentType();

  const displayPlaceholder =
    props.value && !!props.value.length ? '' : placeholder;

  return (
    <FormMultiselect
      {...props}
      title={title}
      description={description}
      placeholder={displayPlaceholder}
      data={data?.map(item => ({
        label: item.name,
        value: item.id.toString(),
      }))}
      rightSection={isLoading ? <Loader size='xs' /> : null}
      searchable
    />
  );
};
